<script setup lang="ts">
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { ref, computed } from 'vue'
    import { SelectFieldSingle } from '@/js/components/Common'
    import { useFachbereichStore } from '@/js/stores/fachbereich'

    const props = defineProps({
        fachbereichId: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Department | Fachbereich' : 'Fachbereich'
    )

    const emit = defineEmits(['fachbereichSaved'])
    const fachbereichStore = useFachbereichStore()

    const fachbereichName = computed(() => {
        const fachbereich = fachbereichStore.getFachbereichById(props.fachbereichId)

        return fachbereich.kurzName
    })
    const fachbereichOptions = computed(() =>
        fachbereichStore.getFachbereiche.map((fachbereich: Fachbereich) => {
            return {
                title: fachbereich.kurzName,
                value: fachbereich.fachbereichId
            }
        })
    )

    const editValue = ref('')

    function handleEditStart() {
        editValue.value = { title: fachbereichName.value, value: props.fachbereichId }
    }

    function handleEditAbort() {
        editValue.value = ''
    }

    const saveFachbereich = () => {
        emit('fachbereichSaved', editValue.value.value)
    }
</script>

<template>
    <single-edit
        edit-key="fachbereich"
        :title="title"
        :entry="fachbereichName"
        :auto-complete-data="fachbereichOptions"
        :allowEdit="allowEdit"
        :tool-tip="tooltip"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
        @text-saved="saveFachbereich"
    >
        <template #edit-component>
            <select-field-single
                v-model="editValue"
                :items="fachbereichOptions"
                return-object
                density="default"
            />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped></style>
